var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { defineStore } from "pinia";
import Vue, { computed, ref } from "vue";
import { prependPath } from "@/utils/redirect";
export const useJobMetricsStore = defineStore("jobMetricsStore", () => {
    const jobMetricsByHdaId = ref({});
    const jobMetricsByLddaId = ref({});
    const jobMetricsByJobId = ref({});
    const getJobMetricsByDatasetId = computed(() => {
        return (datasetId, datasetType = "hda") => {
            var _a;
            const jobMetricsObject = datasetType === "hda" ? jobMetricsByHdaId : jobMetricsByLddaId;
            return (_a = jobMetricsObject.value[datasetId]) !== null && _a !== void 0 ? _a : [];
        };
    });
    const getJobMetricsByJobId = computed(() => {
        return (jobId) => {
            var _a;
            return (_a = jobMetricsByJobId.value[jobId]) !== null && _a !== void 0 ? _a : [];
        };
    });
    function fetchJobMetricsForDatasetId(datasetId, datasetType = "hda") {
        return __awaiter(this, void 0, void 0, function* () {
            if (jobMetricsByHdaId.value[datasetId] || jobMetricsByLddaId.value[datasetId]) {
                return;
            }
            const path = prependPath(`api/datasets/${datasetId}/metrics?hda_ldda=${datasetType}`);
            const jobMetrics = (yield axios.get(path)).data;
            const jobMetricsObject = datasetType == "hda" ? jobMetricsByHdaId : jobMetricsByLddaId;
            Vue.set(jobMetricsObject.value, datasetId, jobMetrics);
        });
    }
    function fetchJobMetricsForJobId(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (jobMetricsByJobId.value[jobId]) {
                return;
            }
            const path = prependPath(`api/jobs/${jobId}/metrics`);
            const jobMetrics = (yield axios.get(path)).data;
            Vue.set(jobMetricsByJobId.value, jobId, jobMetrics);
        });
    }
    return {
        jobMetricsByHdaId,
        jobMetricsByLddaId,
        jobMetricsByJobId,
        getJobMetricsByDatasetId,
        getJobMetricsByJobId,
        fetchJobMetricsForJobId,
        fetchJobMetricsForDatasetId,
    };
});
